import logEvent from "lib/ga/miscEvent";
import logFileDownload from "lib/ga/fileDownload";
import Download from "components/svg/downloads/download";
import styles from './downloads.module.css';
import globalStyles from '../result.module.css';

interface Props {
    uri: string;
    resource_type: string;
    title: string;
    altTag: string;
    file_type: string;
    id: number;
    type: string;
}
const DownloadsDisplay = ({uri, resource_type, title, altTag, file_type, id, type}: Props) => {
    return (
        <a className={styles.download}
            href={`${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${uri}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
                logFileDownload({
                extension: file_type,
                name: uri,
                classes: "",
                domain: "",
                id: id,
                text: title,
                type: type,
                url: `${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${uri}`,
                resource_type: resource_type
                });
                logEvent({
                category: "Download",
                action: "Download Click",
                label: `Download: ${resource_type}`,
                });
            }}
            >
            <div className={styles.iconRed}>
                {resource_type == "brochure" || resource_type == "site_plan" ? (
                <img
                    alt={altTag}
                    src={process.env.NEXT_PUBLIC_APP_CDN_URL + "/icons/property/" + resource_type + ".svg"}
                ></img>
                ) : (
                <img
                    className={styles.oldImg}
                    alt={altTag}
                    src={process.env.NEXT_PUBLIC_APP_CDN_URL + "/icons/download-" + resource_type + ".svg"}
                ></img>
                )}
            </div>
            <div className={styles.downloadType}>
                <div className={globalStyles.largeText}>{altTag}</div>
                <p className={globalStyles.lightColorText}>{title}</p>
            </div>
            <div className={`${styles.iconGrey} ${styles.downloadIcon}` }>
                <Download/>
            </div>
        </a>
    )
}

export default DownloadsDisplay;